import "./App.css";
import "./index.css";
import { BrowserRouter } from "react-router-dom";
import AppRoutes from "./app/AppRoutes";
import OktaConfiguration from "./app/okta/OktaConfiguration";
import AppThemeProvider from "./app/theme/AppThemeProvider";

function App() {
  return (
    <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
      <AppThemeProvider>
        <OktaConfiguration>
          <AppRoutes />
        </OktaConfiguration>
      </AppThemeProvider>
    </BrowserRouter>
  );
}

export default App;
